function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export const isIOSChrome = /CriOS/i.test(navigator.userAgent) && /iphone|ipod|ipad/i.test(navigator.userAgent);
export const isSafari = !!(navigator.vendor && navigator.vendor.match(/apple/gi) || navigator.userAgent.match(/safari/gi) && !navigator.userAgent.match(/chrome/gi) || isIOSChrome);
export const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || 'msMaxTouchPoints' in navigator && navigator.msMaxTouchPoints > 0;
export function select(selectorOrParentElement, subSelector) {
  let parent = document;
  let selector = selectorOrParentElement;
  if (typeof selectorOrParentElement !== 'string') {
    parent = selectorOrParentElement;
    if (!subSelector) throw new Error('subSelector must be provided when parentElement is provided!');
    selector = subSelector;
  }
  const el = parent.querySelector(selector);
  if (!el) {
    if (parent !== document) console.error('queried parent: ', parent);
    throw new Error(`Could not locate ${selector}!`);
  }
  return el;
}
export function selectAll(selectorOrParentElement, subSelector) {
  let parent = document;
  let selector = selectorOrParentElement;
  if (typeof selectorOrParentElement !== 'string') {
    parent = selectorOrParentElement;
    if (!subSelector) throw new Error('subSelector must be provided when parentElement is provided!');
    selector = subSelector;
  }
  return Array.from(parent.querySelectorAll(selector));
}
export const ensureWrapped = value => Array.isArray(value) ? value : [value];
export const assertNonNullish = _value => {};
export const blindAssert = _value => {};
export const cast = value => value;
export const sleep = ms => new Promise(r => setTimeout(r, ms));
export function onReady(fn) {
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}
export function onReadyEach(selector, fn) {
  onReady(() => {
    for (const el of selectAll(selector)) {
      fn(el);
    }
  });
}

/**
 * Edge cases were found by using the following regex to search lib.dom.d.ts: addEventListener<K extends keyof [\S]*(?<!HTML|SVG)ElementEventMap
 */

export class DisposalSet {
  constructor() {
    _defineProperty(this, "registeredDisposables", void 0);
    _defineProperty(this, "registeredElements", void 0);
    this.registeredDisposables = new Set();
    this.registeredElements = new Map();
  }
  register(target) {
    if (target instanceof Element || target instanceof Document || target instanceof Window) {
      const registrar = {
        addListener: (event, handler, options) => {
          this.registeredElements.set(target, [...(this.registeredElements.get(target) ?? []), [event, handler]]);
          target.addEventListener(event, handler, options);
          return registrar;
        }
      };
      return registrar;
    } else {
      this.registeredDisposables.add(target);
    }
  }
  [Symbol.dispose]() {
    this.disposeAll();
  }
  disposeAll() {
    for (const [element, listeners] of this.registeredElements.entries()) {
      for (const [eventName, listener] of listeners) {
        element.removeEventListener(eventName, listener);
      }
    }
    for (const disposable of this.registeredDisposables.values()) {
      if (disposable instanceof ResizeObserver) {
        disposable.disconnect();
      } else if (Symbol.dispose in disposable) {
        disposable[Symbol.dispose]();
      } else {
        disposable();
      }
    }
    this.registeredDisposables.clear();
    this.registeredElements.clear();
  }
}